export const generateGETParams = (payload = {}) => {
  const paramsString = Object.keys(payload)
    .map((key) => `${key}=${payload[key]}`)
    .join('&');

  return paramsString;
};
